import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "cicd-pipeline"
    }}>{`CI/CD Pipeline`}</h1>
    <p>{`When it comes to creating a CI/CD pipeline for managing your actions, Adobe I/O Runtime offers a number of tools that can help you build a pipeline that suites your needs. `}</p>
    <p>{`Namespaces can be used to separate your different environments: dev, qe, stage or prod. You can create as many namespaces as you want/need. This enables you to deploy the different versions of your actions to different environments, as you promote a given version all the way up to production.`}</p>
    <p>{`The CLI tools, `}<inlineCode parentName="p">{`wsk`}</inlineCode>{` and `}<inlineCode parentName="p">{`wskdeploy`}</inlineCode>{`, can help you automate deployments: manage action dependencies and create manifest files that describe your packages/actions. You can read more about using `}<inlineCode parentName="p">{`wskdeploy`}</inlineCode>{` `}<a parentName="p" {...{
        "href": "creating_actions.md"
      }}>{`here`}</a>{`. `}</p>
    <p>{`When it comes to exposing your actions as REST APIs, using Swagger definition files helps you to manage the API life cycle: create/edit/delete. You can read more about this `}<a parentName="p" {...{
        "href": "creating_rest_apis.md"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "versioning-actions"
    }}>{`Versioning Actions`}</h2>
    <p>{`One common problem when creating actions is how to handle versioning – how to keep multiple versions of the same action around. An elegant way to solve this problem is to leverage packages.`}</p>
    <p>{`This is how it works: you would create a new package for every release you want push and deploy all your actions in that package. You can use the version number as part of the package name and you can also create a latest package that will always hold the latest version. This way, a client application has complete freedom to: lock on a specific version, use always the latest, or migrate to a newer version.`}</p>
    <p>{`AEM Commerce team documented this approach in a `}<a parentName="p" {...{
        "href": "https://medium.com/adobetech/functions-packaging-and-versioning-in-adobe-i-o-runtime-7accdfd95e0a"
      }}>{`blogpost`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      